export default __webpack_public_path__ + "static/sig_compare_comp1_active-e438a87e060be7346766b179a431c671.png";